import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemePreferenceProvider } from './components/ThemePreferenceContext';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

window['APP_CONFIG'] = {
    API_URL: '',
};

createRoot(rootElement!).render(
    <ThemePreferenceProvider>
        <BrowserRouter basename={baseUrl!}>
            <App />
        </BrowserRouter>
    </ThemePreferenceProvider>
);
